import type { ConceptDef } from '../types';

export const matchLetters: ConceptDef = {
  kind: 'tileMatch',
  id: 'match-letters',
  label: 'Match Letters',
  category: 'Matching',
  description: 'See a letter; tap the identical letter among tiles.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: 'A', answer: 'A' },
      { say: 'B', answer: 'B' },
      { say: 'C', answer: 'C' },
      { say: 'D', answer: 'D' },
      { say: 'E', answer: 'E' },
      { say: 'F', answer: 'F' },
    ],
  },
};
